<template>
  <div class="container" v-if="!this.isMobile">
    <div class="inner bg-white">
      <flash-message class="myCustomClass"></flash-message>
      <loading :active.sync="isLoading" :can-cancel="true"></loading>
      <div class="row acc">
        <!-- sidebar -->
        <div class="col-md-3 sidebar">
          <div class="card default">
            <div class="card-header">Your Account</div>

            <SidebarNav />

          </div>
        </div>

        <div class="col-md-9">
          <div class="row mb-15">
            <div class="col-12">
              <h2>My Delegates</h2>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <p class="lg-text">Here you will see any delegates that you have booked for Elearning, with Elearning credits. You can check the status of their Elearning modules and download any completed training certificates.</p>
              <p class="lg-text">If you have purchased the e-learning course for yourself you can access it in ‘My Courses’ section </p>
            </div>
          </div>

          <div class="row mb-30">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table acc">
                  <thead>
                    <tr>
                      <th>Course</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Enrolled Date</th>
                      <th>Download Certificate</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-if="datas.length  === 0">
                      <td colspan="6">
                        <center>No records !!</center>
                      </td>
                    </tr>
                    <tr v-for="item in datas" :key="item.id" v-if="datas">
                      <td>{{item.title}}</td>
                      <td>{{item.trainee}}</td>
                      <td>{{item.status}}</td>
                      <td>{{item.course_booked_date | formatDates}}</td>
                      <td v-if="item.status != 'Completed' ">-</td>
                      <td v-if="item.status == 'Completed'"><a href="#" @click="getcertLink(item.certificateUrl)">Download Certificate</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <pageBottom></pageBottom>
    </div>
  </div>
  <div class="container py-30 inner bg-white" v-else>
    <loading :active.sync="isLoading" :can-cancel="true"></loading>
    <flash-message class="myCustomClass"></flash-message>

    <!-- intro -->
    <div class="row mb-15 title-row">
      <div class="col-10">
        <h2>My Course</h2>
      </div>
      <div class="col-2 inner">
        <a class="toggle visible-xs">
          <div class="mob-col d-block d-md-none" style="position: relative">
            <div id="nav-open-basket" @click="this.showNav"></div>
          </div>
        </a>
      </div>
    </div>

    <!-- accordion -->
    <div id="accordion" class="acc my-account mt-30">
      <!-- card -->
      <div class="card border-bottom-0 mb-0">
        <div class="card-header" id="heading-1">
          <h5 class="mb-0">
            <router-link
              to="/accounts"
              v-if="$store.state.auth"
              class="collapsed font-weight-light black"
            >Edit Your Details</router-link>
          </h5>
        </div>
      </div>

      <!-- card -->
      <div class="card border-bottom-0 mb-0">
        <div class="card-header" id="heading-2">
          <h5 class="mb-0">
            <router-link
              to="/accounts-passwd"
              v-if="$store.state.auth"
              class="collapsed font-weight-light black"
              aria-controls="collapse-2"
            >Change Your Password</router-link>
          </h5>
        </div>
      </div>

      <!-- card -->
      <div class="card border-bottom-0 mb-0">
        <div class="card-header" id="heading-3">
          <h5 class="mb-0">
            <router-link to="/orderhistory" class="collapsed font-weight-light black">Order History</router-link>
          </h5>
        </div>
      </div>

      <!-- card -->
      <div class="card border-bottom-0 mb-0">
        <div class="card-header" id="heading-4">
          <h5 class="mb-0">
            <router-link
              to="/downloads"
              v-if="$store.state.auth"
              class="collapsed font-weight-light black"
            >Downloads</router-link>
          </h5>
        </div>
      </div>

      <!-- card -->
       

      <!-- card -->
      <div class="card border-bottom-0 mb-0" v-if="JSON.parse(this.$store.state.auth).customer_id">
        <div class="card-header" id="heading-5">
          <h5 class="mb-0">
            <router-link
              to="/accounts-delegate"
              class="collapsed font-weight-light black"
              v-if="$store.state.auth"
            >Book Elearning Courses</router-link>
          </h5>
        </div>
      </div>

      <!-- card -->

      <!-- card -->
      <div class="card border-bottom-0 mb-0" v-if="JSON.parse(this.$store.state.auth).customer_id">
        <div class="card-header" id="heading-6">
          <h5 class="mb-0">
            <a
              class="collapsed font-weight-light black"
              role="button"
              data-toggle="collapse"
              href="#collapse-6"
              aria-expanded="true"
              aria-controls="collapse-6"
            >My Delegates</a>
          </h5>
        </div>

        <div
          id="collapse-6"
          class="collapse show"
          data-parent="#accordion"
          aria-labelledby="heading-6"
        >
          <div class="card-body" v-if="datas.length  === 0">
            <div class="grey-bg">
              <div class="row">
                <div class="col-12">
                  <p class="mb-0">
                    <span class="hl">No records !</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-for="item in datas" :key="item.id" v-if="datas">
            <!-- box -->

            <div class="grey-bg">
              <div class="row">
                <div class="col-12">
                  <p class="mb-0">
                    <span class="hl">Course: {{item.title}}</span>
                  </p>
                  <p class="mb-0">
                    <span class="hl">Agency: {{item.trainee}}</span>
                  </p>
                  <p class="mb-0">
                    <span class="hl">Status: {{item.status}}</span>
                  </p>
                  <p class="mb-0">
                    <span class="hl">Enrolled Date: {{item.course_booked_date | formatDates}}</span>
                  </p>
                  <p class="mb-0">
                    <span class="hl">Take Course: {{item.status}}</span>
                  </p>
                  <p class="mb-0">
                    <span class="hl" v-if="item.status != 'Completed'">Download Certificate: -</span>
                    <span class="hl" v-if="item.status == 'Completed'">Download Certificate: <a href="#" @click="getcertLink(item.certificateUrl)">Download Certificate</a></span>
                  </p>
                  <p class="mb-0">
                    <span class="hl">Info: -</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- card -->
      <div class="card border-bottom-0 mb-0">
        <div class="card-header" id="heading-7">
          <h5 class="mb-0">
            <router-link
              to="/mycourse"
              class="collapsed font-weight-light black"
              v-if="$store.state.auth"
            >My Courses</router-link>
          </h5>
        </div>
      </div>

      <div class="card border-bottom-0 mb-0">
        <div class="card-header" id="heading-8">
          <h5 class>
            <router-link
              to="/logout"
              class="collapsed font-weight-light black"
              v-if="$store.state.auth"
            >Logout</router-link>
          </h5>
        </div>
      </div>
    </div>

    <div class="m-basket-bottom">
      <pageBottom></pageBottom>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
require('vue-flash-message/dist/vue-flash-message.min.css');
import Vuelidate from 'vuelidate';
import VueFlashMessage from 'vue-flash-message';
import moment from 'moment';
Vue.use(Vuelidate);
Vue.use(VueFlashMessage);
import Helper from "../../helper.js";
import CreditSystem from "@/services/CreditSystem";
import CheckoutApi from "@/services/Checkout";
import Users from "@/services/Users";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import pageBottom from "./pageBottom.vue";
Vue.filter('formatDates', function(value) {
  return (value) ? moment(value).format('DD-MM-YYYY') : "";
});
import SidebarNav from "../components/SidebarNav.vue";
export default {
  name: "mydelegate",
  mixins: [Helper],
  data() {
    return {
      errors: [],
      submitted: false,
      isLoading: false,
      datas: []
    };
  },
  components: {
    Loading,
    pageBottom,
    SidebarNav
  },
  mounted() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      $("#nav").hide();
      $("#body").removeClass("mob-bg");
    }
    if (!this.$store.state.auth) {
      this.$router.replace(this.$route.query.redirect || "/");
    }
    this.isLoading = true;
    var customer_id = JSON.parse(this.$store.state.auth).customer_id;
    Users.delegate(customer_id)
      .then(request => {
        this.isLoading = false;
        if (request.data) {
          this.datas = request.data;
        }
      })
      .catch(error => {
        console.log(error);
        this.isLoading = false;
      });
  },
  methods: {
    getcertLink(link) {
        window.open(link, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.basket {
  background-color: white;
  padding: 61px 0;
  .pad-top {
    padding: 20px;
  }
  .empty-content {
    width: 100%;
    padding: 15px;
    float: left;
    border-radius: 5px;
    .dur {
      width: 100%;

      background: #f7f9fe;
      border: 1px solid #cdd3e3;
      border-radius: 7px;
      margin: 102px 0;
      p {
        font-size: 22px;
        padding: 20px;
        margin: 0;
      }
    }
  }
  .basket-content {
    display: none;
  }
  .rgt-content {
    width: 100%;
    padding: 15px;
    float: left;
    border-radius: 5px;
    margin-bottom: 15px;
    background-color: white;
  }
  .table-main {
    width: 100%;
    border: 0;
    display: inline-block;
  }
  .table-curved {
    border-collapse: collapse;
    border: 0 solid #cdd3e3;
    border-radius: 6px;
    border-left: 0;
    border-right: 1px solid #dee2e6;
    th {
      background: #f7f9fe;
      padding: 6px 10px 6px 13px;
      border: 1px solid #cdd3e3;
      background: #f7f9fe none repeat scroll 0 0;
      font-size: 15px;
      border-right: 0 none !important;
      border-bottom: 1px solid #cdd3e3 !important;
    }
    th:first-child {
      border-radius: 6px 0 0 0;
    }
    tr.bt-bdr td {
      padding: 6px 10px 6px 13px;
    }
    td {
      background: #fff;
      font-size: 14px;
      border-right: 0 none !important;
      border-top: 0 !important;
      padding: 6px 10px 6px 13px;
      .qty-btn {
        width: 70%;
        float: left;
        margin-top: 5px;
        .remove {
          font: normal 14px Arial, Helvetica, sans-serif;
          color: #b8452a;
          text-decoration: none;
          border: 0;
          background-color: white;
        }
      }
      .qty-div {
        width: 30%;
        float: left;
        .qty {
          background: #f7f7f7;
          border: 1px solid #e3e3e3;
          color: #72675f;
          padding: 2px 3px;
          text-align: center;
          width: 23px;
          margin-right: 5px;
          height: 22px;
          display: inline-block;
          border-radius: 4px;
          margin-top: 3px;
        }
      }
      .total-a {
        font-size: 20px;
        font-weight: 700;
      }
    }
    .bt-btn {
      width: 218px;
      display: inline-block;
      padding: 15px 0 13px;
      outline: none;
      .tbl-btn {
        width: 195px;
        text-align: center;
        display: inline-block;
        padding: 8px 0;
        color: #fff;
        font-size: 15px;
        font-weight: 700;
        background: #2ba245;
        transition: all 0.8s ease;
        border: 0;
        border-radius: 35px;
        outline: none;
      }
    }

    .cal {
      border-top: 0 !important;
      border-bottom: 0;
    }
    .total-bill {
      border-top: 1px solid #dee2e6;
      .bt-txt,
      .bt-or {
        display: inline-block;
        font: normal 20px Arial, Helvetica, sans-serif;
        color: #888686;
        padding: 15px 0 13px;
        outline: none;
      }
    }
  }
  tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  .cart {
    .cart-col {
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
      padding-right: 15px;
      padding-left: 15px;
    }
  }
}

@media (max-width: 575px) {
  #accordion.my-account .card .card-header:last-child {
    border-bottom: 1px solid rgb(0, 0, 0);
  }
  .m-basket-bottom .bodyBottom p {
    color: black;
  }
  .basket {
    padding: 1px 0px;
  }
  .btns-wrap {
    padding: 15px;
    padding-top: 5px;
    padding-bottom: 0;
    .btn {
      margin-bottom: 15px;
    }
  }
  .cart {
    .cart-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      padding-right: 15px !important;
      padding-left: 15px !important;
    }
    p {
      font-size: 16px;
      margin-bottom: 4px;
    }
    .m-txt {
      margin-left: 5px;
      margin-right: 8px;
      border: 1px solid #8c8c89;
      text-align: center;
      width: 40px;
    }
  }
  .btn-pri-display {
    display: none;
  }
  .m-checkout-wrap {
    width: 100%;
    .btn-pri {
      width: 100%;
      background: #40a535;
      border-radius: 0;
      color: #ffffff !important;
      padding: 15px 15px;
      margin-top: 10px;
    }
  }
  .title-row {
    margin-top: 20px;
    h2 {
      font-size: 20px;
    }
  }
  #nav-open-basket {
    width: 35px;
    height: 35px;
    border: 2px solid #000000;
    border-radius: 50px;
    background-image: url("../images/menu-black.png");
    //bottom: 0px;
    right: 8px;
    position: absolute;
  }
}
</style>

